import LegalLayout, { Section } from "../components/landing/LegalLayout";

export default function JogoResponsavel() {
  return (
    <LegalLayout title="Jogo Responsável" updated="Última atualização: julho de 2026" testid="page-jogo-responsavel">
      <Section n="01" title="Nosso compromisso">
        <p>
          O DUELO é um jogo de habilidade para maiores de 18 anos. Nosso
          compromisso é oferecer diversão competitiva com transparência,
          limites claros e ferramentas de proteção ao jogador.
        </p>
      </Section>
      <Section n="02" title="Ferramentas de proteção">
        <p>
          Dentro do app você pode definir limites de depósito, limites de perda
          e pausas temporárias. Também oferecemos autoexclusão: ao ativá-la,
          sua conta fica bloqueada para duelos valendo créditos pelo período
          escolhido.
        </p>
      </Section>
      <Section n="03" title="Sinais de alerta">
        <p>
          Jogar além do planejado, esconder gastos de pessoas próximas, tentar
          recuperar perdas com novas partidas ou sentir ansiedade ao ficar sem
          jogar são sinais de que é hora de pausar e buscar apoio.
        </p>
      </Section>
      <Section n="04" title="Regras de ouro">
        <p>
          Jogue apenas com valores que não fariam falta. Defina um orçamento
          antes de começar, faça pausas regulares e trate os créditos como
          entretenimento — nunca como fonte de renda.
        </p>
      </Section>
      <Section n="05" title="Onde buscar ajuda">
        <p>
          Se o jogo deixou de ser diversão, converse com alguém de confiança ou
          procure apoio especializado: Jogadores Anônimos Brasil
          (jogadoresanonimos.com.br) ou o CVV — Centro de Valorização da Vida,
          pelo telefone 188, disponível 24 horas.
        </p>
      </Section>
    </LegalLayout>
  );
}
